export default __webpack_public_path__ + "static/media/mixkit-software-interface-remove-2576 .4d124ee8.mp3";